import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPyramide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormPyramide"><Path fillRule="evenodd" clipRule="evenodd" d="M23.5332 16.3516L12.001 22.1182L0.46875 16.3516L12.001 1.36035L23.5332 16.3516ZM12.001 19.8818L20.4678 15.6475L12.001 4.63965V19.8818Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPyramide;
